<template>
  <div
    id="switch-gen"
    v-if="!isLoading"
    :style="backgroundImage"
    :class="{
      'font-light': bodyBackground && bodyBackground.contrast === 'dark',
      'font-dark': bodyBackground && bodyBackground.contrast === 'light',
    }"
  >
    <portal-target name="destination" mode="out-in"></portal-target>
    <ButtonCloseGenerator />

    <div class="main">
      <transition name="next" mode="out-in">
        <StepSwitchGear v-if="currentStep === 1" />
        <StepBrandColorSelection v-else-if="currentStep === 2" />
        <StepFinishOrder v-else-if="currentStep === 3" />
      </transition>
    </div>

    <AppHeader />
    <AppFooter />

    <PopupConfirm ref="confirm" />

    <template v-if="popupShow">
      <transition name="popup-modal">
        <PopupNoProductsAvailable
          v-if="['brand', 'color'].includes(popupType)"
          :popup-type="popupType"
        />
        <PopupOrder v-else-if="popupType === 'order'" />
      </transition>
    </template>
    <transition name="fade" mode="out-in">
      <div class="backdrop" v-if="isLoading">
        <LdsRippleWaiter />
      </div>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import ButtonCloseGenerator from './components/utilities/ButtonCloseGenerator';
import AppHeader from './components/header/AppHeader';
import AppFooter from './components/footer/AppFooter';
import PopupConfirm from './components/utilities/PopupConfirm';
import PopupOrder from './components/popups/order/PopupOrder';
import StepBrandColorSelection from './components/steps/StepBrandColorSelection';
import StepSwitchGear from './components/steps/StepSwitchGear';
import StepFinishOrder from './components/steps/StepFinishOrder';
import PopupNoProductsAvailable from './components/popups/PopupNoProductsAvailable';
import LdsRippleWaiter from '@/components/utilities/LdsRippleWaiter.vue';
import stepBrowserHistory from '@/mixins/stepBrowserHistory';

export default {
  name: 'App',

  props: ['product_img'],

  mixins: [stepBrowserHistory],

  components: {
    LdsRippleWaiter,
    PopupNoProductsAvailable,
    StepFinishOrder,
    StepSwitchGear,
    StepBrandColorSelection,
    PopupOrder,
    PopupConfirm,
    AppFooter,
    AppHeader,
    ButtonCloseGenerator,
  },

  watch: {
    buildProducts: {
      immediate: true,
      handler(products) {
        if (
          this.buildRooms.length === 0 &&
          products.length === 0 &&
          this.currentStep !== 1
        ) {
          this.setStep(1);
        }
      },
    },
    allBuildProducts: {
      immediate: true,
      async handler() {
        if (this.currentStep === 1) {
          return;
        }

        const roomWithoutProducts = this.buildRooms.find(
          (room) => room.products.length === 0
        );

        if (roomWithoutProducts) {
          this.$store.commit('build/setActiveRoom', roomWithoutProducts.id);
          this.$store.commit('build/setLine', null);
          this.setStep(1);
        }
      },
    },
  },

  methods: {
    ...mapMutations('step', ['setStep']),
  },

  computed: {
    ...mapState('step', ['currentStep']),
    ...mapState('popup', { popupShow: 'show', popupType: 'type' }),
    ...mapGetters({
      categories: 'data/getCategories',
      bodyBackground: 'getBodyBackground',
      buildProducts: 'build/getProducts',
      buildRooms: 'build/getRooms',
      allBuildProducts: 'build/getAllProducts',
      isLoading: 'isLoading',
    }),
    backgroundImage() {
      if (!this.bodyBackground || !this.bodyBackground.image) {
        return '';
      }

      if (this.bodyBackground.type === 'custom') {
        return {
          backgroundImage: `url(${this.bodyBackground.image})`,
        };
      }

      const url = this.bodyBackground.image.startsWith('http')
        ? `url(${this.bodyBackground.image})`
        : `url(${this.$store.state.appPath}/images/${this.bodyBackground.image})`;

      return {
        backgroundImage: url,
      };
    },
  },
};
</script>

<style lang="scss">
@import 'sass/app';
</style>
